import { ITableColumn } from "components/interfaces";
import { computed, makeObservable } from "mobx";
import { lang } from "../i18nLang";
import { formatCode } from "../utils";
import { AdvanceStore, MeasurementListStore } from "./";

class Store {
  public readonly blankColumns: number = 3;
  public readonly columns: ITableColumn[] = [
    {
      dataKey: "code",
      label: lang("fields.code"),
      align: "right",
      width: 120,
    },
    {
      dataKey: "title",
      label: lang("fields.title"),
    },
    {
      dataKey: "date",
      label: lang("fields.createdDate"),
      width: 150,
    },
    /* Os valores fixos sao necessarios para manter a tabela alinhada */
    {
      dataKey: "total",
      label: lang("fields.value"),
      width: 150,
      monetary: true,
      align: "right",
    },
    {
      dataKey: "installment",
      label: lang("fields.installment"),
      width: 150,
    },
    {
      dataKey: "maturity",
      label: lang("fields.maturity"),
      width: 150,
    },
    {
      dataKey: "link",
      label: lang("advances.fields.link"),
      width: 150,
    },
  ];
  public readonly subColumns: ITableColumn[] = [
    /* Os valores fixos sao necessarios para manter a tabela alinhada */
    {
      dataKey: "value",
      label: "",
      width: 150,
      monetary: true,
      align: "right",
    },
    {
      dataKey: "parcel",
      label: "",
      width: 150,
    },
    {
      dataKey: "maturityDate",
      label: "",
      width: 150,
    },
    {
      dataKey: "measurementLink",
      label: "",
      width: 300,
    },
  ];

  constructor() {
    makeObservable(this, {
      rows: computed,
    });
  }

  get rows() {
    const formatInstallments = (installments) =>
      installments.map((installment) => {
        return {
          ...installment,
          parcel: `${installment.id}/${installments.length} parcela`,
          maturityDate: installment.maturityDate.toLocaleDateString("pt-br"),
          measurementName: MeasurementListStore.getMeasurementName(
            installment.measurementId
          ),
        };
      });

    return AdvanceStore.advances.map((advance) => ({
      id: advance.uid,
      code: formatCode(advance.code),
      title: advance.title,
      date: advance.getDate()?.toLocaleDateString("pt-br"),
      total: advance.total,
      installments: formatInstallments(advance.installments),
    }));
  }
}

const AdvanceTableStore = new Store();
export default AdvanceTableStore;
